import { t } from '@lingui/macro';
import { getCustomerSentimentRevisions } from 'api/api';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React, { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useApi } from '../../../hook/utils';
import { chartsDateRangeSelector } from '../utils';
import InsightConversationList from './InsightConversationList';
import InsightStatisticCard from './InsightStatisticCard';

const MOCK_SENTIMENT_REVISIONS = {
  data: [
    {
      inbox: { id: 5105, name: 'N**************c' },
      staff: { id: 28, name: 'doopage.test.1' },
      sentiment_score: -1,
      description: 'Khách phàn nàn giao hàng trễ, yêu cầu hoàn tiền.',
    },
    {
      inbox: { id: 5106, name: 'v**n' },
      staff: { id: 29, name: 'Test doopage 2' },
      sentiment_score: -1,
      description: 'Khách chê chất lượng sản phẩm không như quảng cáo.',
    },
    {
      inbox: { id: 5107, name: 'D********t' },
      staff: { id: 30, name: 'Doopage cross manager test 1' },
      sentiment_score: -1,
      description: 'Khách bức xúc vì phải chờ phản hồi quá lâu.',
    },
  ],
};

const USE_MOCK_DATA = process.env.NODE_ENV === 'development';

const PAGE_SIZE = 20;

const toItem = (item) => ({ ...item, secondary: item.description });

const CustomerSentimentRevisions = (props) => {
  const {
    getApi = getCustomerSentimentRevisions,
    title = t`Hội thoại cần sự chú ý`,
    canDelete,
    code,
    score,
  } = props;
  const { since, until } = useSelector(chartsDateRangeSelector());
  const { loading, doFetch } = useApi();
  const [error, setError] = useState({});
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);

  const fetchPage = async (nextPage) => {
    const { error, data, ...rest } = await doFetch(
      getApi({ since, until, page: nextPage, page_size: PAGE_SIZE, score: score }),
    );
    if (error) {
      setError({ error, ...rest });
      return { list: [], more: false };
    }
    const body = data || {};
    const list = (body.data || []).map(toItem);
    const more = body.paging ? body.paging.next != null : list.length >= PAGE_SIZE;
    return { list, more };
  };

  useEffect(() => {
    if (USE_MOCK_DATA) return;
    (async () => {
      if (!since || !until) return;
      setError({});
      setItems([]);
      setPage(1);
      setHasMore(false);
      const { list, more } = await fetchPage(1);
      setItems(list);
      setHasMore(more);
    })();
  }, [since, until, score]);

  const handleLoadMore = async () => {
    if (loadingMore || !hasMore) return;
    setLoadingMore(true);
    const nextPage = page + 1;
    const { list, more } = await fetchPage(nextPage);
    setItems((prev) => [...prev, ...list]);
    setPage(nextPage);
    setHasMore(more);
    setLoadingMore(false);
  };

  const items_ = USE_MOCK_DATA ? MOCK_SENTIMENT_REVISIONS.data.map(toItem) : items;

  return (
    <InsightStatisticCard
      title={title}
      canDelete={canDelete}
      code={code}
      loading={!USE_MOCK_DATA && loading && isEmpty(items)}
      error={!USE_MOCK_DATA ? error : {}}
      showEmpty={isEmpty(items_)}
      onLoadMore={!USE_MOCK_DATA && hasMore ? handleLoadMore : undefined}
      loadingMore={loadingMore}>
      <InsightConversationList items={items_} />
    </InsightStatisticCard>
  );
};

CustomerSentimentRevisions.propTypes = {
  getApi: PropTypes.func,
  title: PropTypes.string,
  canDelete: PropTypes.bool,
  code: PropTypes.string,
};

export default memo(CustomerSentimentRevisions);
